var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcon36BlogPizza(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeWidth: 2,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23 6.07a14.44 14.44 0 0 0-22 0L12 23 23 6.07z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.57 9.81C18.34 7.17 15.44 5.57 12 5.57c-3.38 0-6.23 1.54-8.45 4.1"
  }))));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+DQogIDxnIHN0cm9rZT0iIzAwMCIgc3Ryb2tlLXdpZHRoPSIyIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCI+DQogICAgPHBhdGggZD0iTTIzIDYuMDdhMTQuNDQgMTQuNDQgMCAwIDAtMjIgMEwxMiAyMyAyMyA2LjA3eiIvPg0KICAgIDxwYXRoIGQ9Ik0yMC41NyA5LjgxQzE4LjM0IDcuMTcgMTUuNDQgNS41NyAxMiA1LjU3Yy0zLjM4IDAtNi4yMyAxLjU0LTguNDUgNC4xIi8+DQogIDwvZz4NCjwvc3ZnPg0K";
export { SvgIcon36BlogPizza as ReactComponent };